import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptorFn,
  HttpErrorResponse,
  HttpHandlerFn,
  HttpStatusCode
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { environment } from '../../../environments/environment';
import { inject } from '@angular/core';

@Injectable()
export class AuthInterceptor {

  constructor(private authService: AuthService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (request.url.includes(environment.jira.tokenEndpoint)) {
      request = request.clone({
        setHeaders: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Accept': 'application/json'
        },
        withCredentials: true
      });
      return next.handle(request);
    }

    const accessToken = this.authService.getAccessToken();
    let headers = request.headers;
    
    if (accessToken) {
      headers = headers.set('Authorization', `Bearer ${accessToken}`);
    }
    
    if (request.url.includes(environment.jira.baseUrl)) {
      headers = headers
        .set('X-Atlassian-Token', 'no-check')
        .set('Accept', 'application/json');
    }

    request = request.clone({
      headers,
      withCredentials: true
    });
    
    // Handle the request
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === HttpStatusCode.Unauthorized && accessToken) {
          this.authService.logout().catch(console.error);
        }
        
        console.error('API Error:', {
          status: error.status,
          url: request.url,
          error: error.error
        });
        
        return throwError(() => error);
      })
    );
  }

}

export const authInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const authService = inject(AuthService);
  const interceptor = new AuthInterceptor(authService);
  return interceptor.intercept(req, { handle: next } as HttpHandler);
};